import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { api, apiError } from "@/lib/api";

export function ForgotForm({ initialEmail, onBack }) {
  const [email, setEmail] = useState(initialEmail || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(null);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { setSent((await api.post("/auth/forgot-password", { email })).data.message); }
    catch (err) { setError(apiError(err)); }
    finally { setBusy(false); }
  };
  if (sent) return (
    <div className="w-full max-w-sm space-y-4" data-testid="forgot-sent">
      <MailCheck className="h-8 w-8 text-primary" />
      <h2 className="font-heading text-2xl font-bold">Check your email</h2>
      <p className="text-sm text-muted-foreground">{sent} The link works once and expires in 1 hour. Check your spam folder if you don't see it.</p>
      <button type="button" onClick={onBack} className="text-sm text-primary hover:underline" data-testid="forgot-back-btn">Back to sign in</button>
    </div>
  );
  return (
    <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="forgot-form">
      <div>
        <h2 className="font-heading text-2xl font-bold">Reset your password</h2>
        <p className="text-sm text-muted-foreground">Enter your account email and we'll send you a link to choose a new password.</p>
      </div>
      <label className="block text-sm">Email
        <input className="field mt-1 w-full" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" required />
      </label>
      {error && <div className="rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="forgot-error">{error}</div>}
      <button disabled={busy} className="flex h-10 w-full items-center justify-center gap-2 rounded-md bg-primary text-sm font-medium text-primary-foreground hover:opacity-90" data-testid="forgot-submit-btn">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Send reset link
      </button>
      <button type="button" onClick={onBack} className="w-full text-center text-sm text-muted-foreground hover:text-foreground" data-testid="forgot-back-btn">Back to sign in</button>
    </form>
  );
}
